// extracted by mini-css-extract-plugin
export default {"addCustomer":"AddCustomer_addCustomer__9e308","errorContainer":"AddCustomer_errorContainer__ix3vT"};